<template>
  <div class="login">
    <div class="login__wrapper">
      <div class="title">{{ !restore_password ? 'Login' : 'Restore password' }}</div>
      <div class="login__form">
        <form @submit.prevent="onSubmit()">
          <div class="login__row">
            <label class="form__label">Email</label>
            <input type="text" class="form__field" :class="{'border border-danger': $v.email.$error}" v-model.trim="$v.email.$model"/>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.email.required">Field is required</div>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.email.email">Invalid Email</div>
          </div>
          <div class="login__row" v-if="!restore_password">
            <label class="form__label">Password</label>
            <input type="password" class="form__field" :class="{'border border-danger': $v.password.$error}" v-model.trim="$v.password.$model"/>
            <div class="text-danger" v-if="!$v.password.minLength">Name must have at least {{$v.password.$params.minLength.min}} letters.</div>
          </div>
          <div class="login__question">
            <a class='login__matter' href='#' @click.prevent="restore_password = !restore_password">{{ !restore_password ? 'Forgot password?' : 'Login' }}</a>
          </div>
          <div class="login__knob">
            <button type="submit" class="login__btn">{{ !restore_password ? 'Login' : 'Restore' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {required, minLength, email} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'
  import {mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: "Login",
    mixins: [validationMixin],
    data() {
      return {
        restore_password: false,
        email: '',
        password: '',
      }
    },
    validations: {
      email: {required, email},
      password: {required, minLength: minLength(4)},
    },

    computed: {
      ...mapGetters([
        'getAuthUser'
      ])
    },
    methods: {
      ...mapMutations([
        'setUser',
        'logout',
      ]),
      ...mapActions([
        'login',
        'restorePassword',
      ]),
      onSubmit() {
        this.$v.$touch()
        if (this.restore_password) {
          if (this.$v.email.required && this.$v.email.email) {
            this.restorePassword({email: this.email})
            this.email = ''
            this.restore_password = false
            this.$v.$reset()
          }
        } else {
          if (!this.$v.$invalid) {
            const user = {
              email: this.email,
              password: this.password
            }
            this.login(user)
          }
        }
      }
    }
  }
</script>

<style>

</style>